import { Dialog, styled } from '@mui/material'

export const buttonStyles = {
  padding: '2px 8px',
}

export const Container = styled(Dialog)(({ theme }) => ({}))
